import { useMemo, useState } from "react";

import { GroupList } from "./components/GroupList";
import { InsightHeader } from "./components/InsightHeader";
import { RankingTable } from "./components/RankingTable";
import { StorePlanList } from "./components/StorePlanList";

import { currencyFormatter } from "../../../../utils/formatter/formatter";
import { MIX_SUMMARY, MIX_GROUPS, MIX_GROUP_DETAILS, TIER_FILTER_TAGS } from "./mixQualification.data";

const DARK_GREEN = "#15803d";

// ícone de tendência 
const TrendingUpIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#fff"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M16 7h6v6" />
    <path d="m22 7-8.5 8.5-5-5L2 17" />
  </svg>
);

// abas internas
const MIX_TABS = { RANKING: "ranking", STORE_PLAN: "store_plan" };

// Tela "Qualificação de MIX" 
export const MixQualificationTab = () => {

  const [selectedGroupId, setSelectedGroupId] = useState(MIX_GROUPS[0]?.id);
  const [activeTab, setActiveTab] = useState(MIX_TABS.RANKING);

  const selectedGroup = useMemo(() => MIX_GROUPS.find(g => g.id === selectedGroupId), [selectedGroupId]);
  const detail = MIX_GROUP_DETAILS[selectedGroupId];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14, flex: 1, minHeight: 0 }}>

      {/* card verde: ganho total esperado */}
      <section style={{
        background: "linear-gradient(90deg, #eafbf1 0%, #f3fdf6 100%)",
        border: "1px solid #cdeedb", borderRadius: "14px", padding: "18px 24px",
        display: "flex", alignItems: "center", justifyContent: "space-between", flexShrink: 0,
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <span style={{
            width: 44, height: 44, borderRadius: "50%", backgroundColor: "#16a34a",
            display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
          }}>
            <TrendingUpIcon />
          </span>
          <div>
            <p style={{ fontSize: "11px", fontWeight: "700", color: "#2ea043", letterSpacing: "0.06em" }}>
              GANHO TOTAL ESPERADO
            </p>
            <p style={{ fontSize: "26px", fontWeight: "800", color: DARK_GREEN, margin: "2px 0" }}>
              {currencyFormatter.format(MIX_SUMMARY.totalExpectedGain)}
            </p>
            <p style={{ fontSize: "12px", color: "#5a8a6b" }}>
              Soma do ganho projetado nos {MIX_SUMMARY.groupsCount} grupos de produto
            </p>
          </div>
        </div>

        <div style={{ display: "flex", gap: 32 }}>
          <div style={{ textAlign: "right" }}>
            <p style={{ fontSize: "10.5px", color: DARK_GREEN, fontWeight: "400" }}>GRUPOS</p>
            <p style={{ fontSize: "18px", fontWeight: "700", color: DARK_GREEN }}>{MIX_SUMMARY.groupsCount}</p>
          </div>
          <div style={{ textAlign: "right" }}>
            <p style={{ fontSize: "10.5px", color: DARK_GREEN, fontWeight: "400" }}>MAIOR GANHO</p>
            <p style={{ fontSize: "18px", fontWeight: "700", color: DARK_GREEN }}>
              {currencyFormatter.format(MIX_SUMMARY.highestGain)}
            </p>
          </div>
        </div>
      </section>

      {/* lista de grupos + painel da direita — os dois moram dentro do MESMO
          card agora (sem gap), separados só por uma linha vertical fina */}
      <div style={{
        display: "flex", flex: 1, minHeight: 0,
        backgroundColor: "#fff", border: "1px solid #e5e5e5",
        borderRadius: "12px", boxShadow: "0 1px 3px rgba(0,0,0,0.04)", overflow: "hidden",
      }}>

        <GroupList
          groups={MIX_GROUPS}
          selectedGroupId={selectedGroupId}
          onSelectGroup={setSelectedGroupId}
        />

        <section style={{
          flex: 1, minWidth: 0, height: "100%", minHeight: 0,
          borderLeft: "1px solid #e5e5e5",
          display: "flex", flexDirection: "column", overflow: "hidden",
        }}>

          {/* abas: ranking empresa / plano por loja — linha de baixo cinza,
              contorno das abas laranja fino, aba inativa em cinza claro */}
          <div style={{ display: "flex", borderBottom: "1px solid #e5e5e5", padding: "8px 16px 0", flexShrink: 0 }}>
            {[
              { key: MIX_TABS.RANKING, label: "Ranking Empresa" },
              { key: MIX_TABS.STORE_PLAN, label: "Plano por Loja" },
            ].map(tab => {
              const isActive = activeTab === tab.key;
              return (
                <button key={tab.key} onClick={() => setActiveTab(tab.key)} style={{
                  padding: "10px 20px", fontSize: "13px", fontWeight: isActive ? "700" : "500",
                  cursor: "pointer", background: isActive ? "#fff" : "#f7f7f5",
                  border: "1px solid #E8773A", borderBottom: isActive ? "1px solid #fff" : "none",
                  borderRadius: "8px 8px 0 0", color: isActive ? "#1a1a1a" : "#999",
                  marginBottom: "-1px", marginRight: 6,
                  position: "relative", zIndex: isActive ? 1 : 0, outline: "none",
                }}>
                  {tab.label}
                </button>
              );
            })}
          </div>

          {/* só esta área rola — a tela toda fica parada */}
          <div style={{ padding: "16px", overflowY: "auto", flex: 1, minHeight: 0 }}>
            {!detail ? (
              <p style={{ fontSize: "13px", color: "#999" }}>
                Sem dados de exemplo para este grupo — adicione em mixQualification.data.js.
              </p>
            ) : (
              <>
                <InsightHeader
                  groupName={selectedGroup?.name}
                  insight={detail.insight}
                  tags={TIER_FILTER_TAGS}
                />

                {activeTab === MIX_TABS.RANKING && <RankingTable rows={detail.ranking} />}
                {activeTab === MIX_TABS.STORE_PLAN && <StorePlanList stores={detail.stores} />}
              </>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};
